import clsx from 'clsx';
import { FC, HTMLAttributes, PropsWithChildren } from 'react';
import { Card } from '../components/sections/Card';
import { Illustration } from '../components/decoration/Illustrations';

export const DecorativeCard: FC<PropsWithChildren<HTMLAttributes<HTMLDivElement>>> = ({
  className,
  children,
  ...props
}) => {
  return (
    <div
      className={clsx(
        'flex h-screen w-screen items-center justify-center bg-gradient-to-b from-[#B4EEFF] to-[#FFEFDD] px-8'
      )}
    >
      <div className="relative left-4 z-10 hidden md:inline">
        <Illustration />
      </div>
      <Card className={clsx('relative shadow-xl md:-left-4', className)} {...props}>
        {children}
      </Card>
    </div>
  );
};
